
































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbAlert, mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbTooltip, mdbRow, mdbCol, mdbIcon, mdbSelect, mdbInput } from '@folky-tools/mdbvue';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Attribute } from '@/models/references-classification/attribute';
import { AttributeValue } from '@/models/references-classification/attribute-value';
import { ReferenceSkuUnitPriceType } from '@/models/references/reference-sku-unit-price';
import { referencesClassificationService, usersService, referencesService, notificationsService } from '@/services';

@Component({ components: { mdbAlert, mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbTooltip, mdbRow, mdbCol, mdbIcon, mdbSelect, mdbInput, AppSysBar: () => import('@/components/shared/AppSysBar.vue') } })
export default class GenerateReferenceSkusView extends Vue {
    private attributes: Attribute[] = [];
    private generatingSkus: boolean = false;
    private pageContentLoaded: boolean = false;
    private price: string = '';
    private discountedPrice: string = '';
    private unitPrice: string = '';
    private unitPriceTypes: any[] = [];
    private selectedUnitPriceType: any = '';

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.references.generateReferenceSkusView.title');
        const reference = await referencesService.getReference(+this.$route.params.id);
        this.attributes = await referencesClassificationService.getAttributes(reference.businessId!);

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Products,
                scope: UserActionScopeType.Skus,
                entityId: +this.$route.params.id
            })
        );

        setTimeout(() => {
            this.pageContentLoaded = true;
        }, 10);

        this.unitPriceTypes.push({
            value: null,
            text: this.$i18n.t(`common.ellipsis`)
        });
        for (const item in ReferenceSkuUnitPriceType) {
            if (isNaN(Number(item))) {
                this.unitPriceTypes.push({
                    value: item,
                    text: this.$i18n.t(`common.unitOfMeasurement.${item.toString()}`),
                    selected: false
                });
            }
        }

        this.$watch('price', (newValue: string, oldValue: string) => {
            if (this.price === null || this.price === undefined || this.price === '') {
                (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue = null;
                this.discountedPrice = '';
            } else {
                const priceNum = (this.$refs.price as any).$refs.input.$ci.numberValue;
                const discountedPriceNum = (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue;
                if (discountedPriceNum !== null && priceNum !== null && discountedPriceNum > priceNum) {
                    (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue = (this.$refs.price as any).$refs.input.$ci.numberValue - 0.01;
                }
            }
        });

        this.$watch('discountedPrice', (newValue: string, oldValue: string) => {
            const priceNum = (this.$refs.price as any).$refs.input.$ci.numberValue;
            const discountedPriceNum = (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue;
            if (discountedPriceNum !== null && priceNum !== null && discountedPriceNum > priceNum) {
                (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue = (this.$refs.price as any).$refs.input.$ci.numberValue - 0.01;
            }
        });
    }

    private selectAttributeValue(attributeValue: AttributeValue): void {
        attributeValue.selected = !attributeValue.selected;
    }

    private async generateSkus(): Promise<void> {
        this.generatingSkus = true;

        try {
            const attributesClone: Attribute[] = this.attributes.filter(a => a.values.some(v => v.selected)).map(a => a.clone());
            attributesClone.forEach(a => {
                a.values = a.values.filter(v => v.selected);
            });
            const skus = {
                skuAttributes: [...attributesClone],
                price: (this.$refs.price as any).$refs.input.$ci.numberValue,
                discountedPrice: (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue,
                unitPriceType: this.selectedUnitPriceType,
                priceByUnit: (this.$refs.unitPrice as any).$refs.input.$ci.numberValue
            };

            if (await referencesService.generateReferenceSkus(+this.$route.params.id, skus)) {
                notificationsService.showToastSuccessNotification('views.references.generateReferenceSkusView.notifications.generateReferenceSkusSuccess');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasCreated,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.Skus,
                        entityId: +this.$route.params.id
                    })
                );

                this.$router.push(`/products/${this.$route.params.id}/edit-skus${this.$route.query.referenceTitle ? '?referenceTitle=' + this.$route.query.referenceTitle : ''}`);

                return;
            }

            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.generatingSkus = false;
        }
    }

    private onChangeUnitPriceType(value: ReferenceSkuUnitPriceType, text: string) {
        this.selectedUnitPriceType = value;
        if (this.selectedUnitPriceType === null) {
            this.unitPrice = '';
        }
    }
}
